<script>
	export let title;
	export let copy;
</script>

<div class="mt-3">
	<h3 class="text-lg font-medium">{title}</h3>
	<p class="mt-2 text-sm text-gray-500">
		{copy}
	</p>
</div>
